import React from 'react';
import { NudosButton } from 'components/NudosComponents';
import { IProductList, ORDER_STATUS } from 'types/orders';
import { getOrderDetailedData } from 'services/orders';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';
import './ButtonConfirmOrder.scss';

const ButtonConfirmOrder = ({
  orderId,
  loadingData,
  orderStatusName,
  loadingOpenConfirmPaymentModal,
  setLoadingOpenConfirmPaymentModal,
  setShowConfirmPaymentModal,
  setConfirmPaymentData,
  customClassName
}: IButtonConfirmOrder) => {
  const handleOpenConfirmPaymentModal = async () => {
    if (!orderId || loadingOpenConfirmPaymentModal) return;
    setLoadingOpenConfirmPaymentModal(true);
    try {
      const response = await getOrderDetailedData(orderId);
      if (!response) return;
      const { generalData, billingMethod, orderDates } = response;
      const { paymentData, shipmentData } = generalData || {};
      const orgData = generalData?.orgData;

      const countriesShipments = shipmentData?.map(shipment => ({
        id: shipment?.country?.id,
        name: shipment?.country?.name,
        code: shipment?.country?.code,
        flag: shipment?.country?.flag
      }));

      const productListData: IProductList = {
        id: String(orderId),
        orderId,
        organizationName: orgData?.organizationName,
        organizationId: orgData?.organizationId,
        paymentType: paymentData?.paymentMethod ?? undefined,
        total: String(paymentData?.total ?? 0),
        totalUsd: String(paymentData?.totalUsd ?? 0),
        currency: paymentData?.currency,
        paymentLink: paymentData?.paymentLink ?? undefined,
        proofOfPaymentUrl: paymentData?.proofOfPayment ?? undefined,
        billingProvider: billingMethod?.billingProvider as IProductList['billingProvider'],
        committedPaymentDate: paymentData?.committedPaymentDate,
        createdAt: orderDates?.createdAt,
        countriesShipments
      };
      setConfirmPaymentData(productListData);
      setShowConfirmPaymentModal(true);
    } catch {
      displayErrorNotification();
    } finally {
      setLoadingOpenConfirmPaymentModal(false);
    }
  };

  if (loadingData || orderStatusName !== ORDER_STATUS.PENDING) return null;

  return (
    <NudosButton
      handleClick={handleOpenConfirmPaymentModal}
      buttonText="Confirmar orden"
      customClassName={`buttonConfirmOrder ${customClassName}`}
      isButtonDisabled={loadingOpenConfirmPaymentModal}
      isButtonLoading={loadingOpenConfirmPaymentModal}
    />
  );
};

interface IButtonConfirmOrder {
  orderId: number | string;
  loadingData?: boolean;
  orderStatusName: ORDER_STATUS;
  loadingOpenConfirmPaymentModal: boolean;
  setLoadingOpenConfirmPaymentModal: (loading: boolean) => void;
  setConfirmPaymentData: (data: IProductList) => void;
  setShowConfirmPaymentModal: (show: boolean) => void;
  customClassName?: string;
}
export default ButtonConfirmOrder;
